export default __webpack_public_path__ + "static/media/logo.ea03a34c.png";